import * as React from 'react';
import Button from 'components/ButtonDeprecated';
import Text from 'components/Text';
import BoxyBody from 'components/BoxBody';
import { COMPOSER_PATH } from '../routes';

// $FlowFixMe
import './styles/ShareSDKNoCookies.scss';

// This component will display a button that then launches a composer in a new window.
// this is necessary because some browsers (IE Safari) block third party cookies
//   Blocking third party cookies essentially means:
//  if I have the site hosted on www.demoExample.com and this has an iframe in it hosted at remind.com, the iframe wont be able to use cookies for remind.com unless the user already had them.

class ShareSDKNoCookies extends React.Component<any, any> {
  render() {
    return (
      <div className="ShareSDKNoCookiesContainer">
        <div className="ShareSDKNoCookiesContainer-inner">
          <BoxyBody>
            <Text align="center">
              Remind doesn’t have the required cookies to load here. Click below to launch the
              composer in a new browser window.
            </Text>
          </BoxyBody>
          <Button href={COMPOSER_PATH + window.location.search} target="_blank">
            Launch Remind
          </Button>
        </div>
      </div>
    );
  }
}

export default ShareSDKNoCookies;
